import { Component, Renderer2, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, RouterOutlet } from '@angular/router';
import { TopBarComponent } from './components/top-bar/top-bar.component';
import { NotificationsComponent } from './components/notifications/notifications.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  imports: [TopBarComponent, NotificationsComponent, RouterOutlet],
})
export class AppComponent {
  isPrint = false;
  title = 'Recimate';

  constructor(
    private router: Router,
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event.type === 0) {
        if (event.url.startsWith('/print')) {
          if (isPlatformBrowser(this.platformId)) {
            this.renderer.addClass(document.body, 'white');
          }
          this.isPrint = true;
        } else {
          if (isPlatformBrowser(this.platformId)) {
            this.renderer.removeClass(document.body, 'white');
          }
          this.isPrint = false;
        }
      }
    });
  }
}
